import { Consts as ConstsBase } from "@ortho-next/nextray-core";
import { MeshPhongMaterial } from "three";
/**
 * Defines constant data.
 */
export class Consts extends ConstsBase {
  /**	
  * Default Material used to mesh not loaded yet, to avoid null material exception.	
  */
  public static readonly toolMaterial = new MeshPhongMaterial({ color: 0x3f565a, flatShading: true });
  
}
